import { select, on, selectAll, addClass, removeClass, hasClass } from '../helpers/dom'
import debounce from 'lodash/debounce'

const DELAY = 0
const selectors = {
  MENU_NAVIGATION_SELECTOR: '.js-menu-navigation',
  NAV_DROPDOWN_SELECTOR: '.js-nav-dropdown',
  NAV_DROPDOWN_ITEM_SELECTOR: '.js-nav-dropdown-item',
  ACTIVE_CLASS: 'is-active',
  HIDDEN_CLASS: 'hidden',
  HOVER_CLASS: 'hover',
}

class MenuNavigation extends HTMLElement {
  constructor() {
    super()
    this.menuNavigation = select(selectors.MENU_NAVIGATION_SELECTOR, this)
    this.navDropdown = select(selectors.NAV_DROPDOWN_SELECTOR, this)
    this.navDropdownItems = selectAll(selectors.NAV_DROPDOWN_ITEM_SELECTOR, this)
    if (window.innerWidth >= 768) {
      this.attachEvent()
    }
  }

  attachEvent() {
    if (this.menuNavigation && this.menuNavigation.children.length > 0) {
      for (let i = 0; i < this.menuNavigation.children.length; i++) {
        on(
          'mouseover',
          debounce(() => {
            if (this.menuNavigation.children[i].hasAttribute('data-dropdown')) {
              addClass(selectors.ACTIVE_CLASS, this)
            } else {
              removeClass(selectors.ACTIVE_CLASS, this)
            }
            this.navDropdownItems.forEach((item) => addClass(selectors.HIDDEN_CLASS, item))
            removeClass(selectors.HIDDEN_CLASS, this.navDropdown.children[i])
            this.navDropdown.style.height = this.navDropdown.children[i].scrollHeight + 'px'
            addClass(selectors.HOVER_CLASS, this.menuNavigation.children[i].children[0])
          }, DELAY),
          this.menuNavigation.children[i]
        )

        on(
          'mouseout',
          debounce(() => {
            this.navDropdown.style.height = 0
            removeClass(selectors.ACTIVE_CLASS, this)
            removeClass(selectors.HOVER_CLASS, this.menuNavigation.children[i].children[0])
          }, DELAY),
          this.menuNavigation.children[i]
        )
      }
    }

    if (this.navDropdownItems && this.navDropdownItems.length > 0) {
      this.navDropdownItems.forEach((item, index) => {
        on(
          'mouseover',
          debounce(() => {
            this.navDropdown.style.height = item.scrollHeight + 'px'
            if (!hasClass(selectors.ACTIVE_CLASS, this)) {
              addClass(selectors.ACTIVE_CLASS, this)
            }
            addClass(selectors.HOVER_CLASS, this.menuNavigation.children[index].children[0])
          }, DELAY),
          item
        )

        on(
          'mouseout',
          debounce(() => {
            this.navDropdown.style.height = 0
            removeClass(selectors.ACTIVE_CLASS, this)
            removeClass(selectors.HOVER_CLASS, this.menuNavigation.children[index].children[0])
          }, DELAY),
          item
        )
      })
    }
  }
}

customElements.define('menu-navigation', MenuNavigation)
